/**
 * Created with IntelliJ IDEA.
 * User: talf
 * Date: 9/9/13
 * Time: 3:51 PM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {

    window.lpTag = window.lpTag || {};

    var TableViewController = require('web-agent-framework/TableViewController');
    var ShortcutPopupViewController = require('web-agent-viewControllers/ShortcutPopupViewController');

    var AgentShortcutPopup = ShortcutPopupViewController.extend({
        ControllerName: 'AgentShortcutPopup',

        initialize: function (constructorData) {

        },

        events: function () {
            this.bindViewEvent({selector : window, DOMEvent : "resize", callback : this.setPosition});
            var that = this;
            var mainElement = this.getFirstElement(this.LPViewMap.mainElement);
            mainElement.tabIndex = 0;
            mainElement = null;
            this.bindViewEvent({selector:this.LPViewMap.mainElement, DOMEvent : "focus", callback : function() {
                that.shortcutsTable.focus();
            }});
        },

        render: function () {
            this.setPosition();
            this.shortcutsTable.view.focus();
        }
    });

    AgentShortcutPopup.prototype.setPosition = function () {
        if (this.visible && this.view && this.view.parentNode) {
            var hotkeysElement = this.getFirstElement(this.LPViewMap.mainElement);
            this.addClass(hotkeysElement, "scrollable_hk");
            var bodyHeight = this.getComputedStyle(this.view.parentNode, "height", 10);
            var hotkeysTableElement = this.getFirstElement(this.LPViewMap.tablePlaceholder);
            var tableHeight = this.getComputedStyle(hotkeysTableElement, "height", 10);
            hotkeysElement.style.marginTop = (-1 * tableHeight / 2 - 18) + "px";
            var maxHeight = Math.round(bodyHeight * 0.5);  //maxHeight if hotkeysTable should be at most 1/2 of body
            hotkeysTableElement.style.maxHeight = maxHeight + "px";

            if (maxHeight > tableHeight) { //scroll deactivated - no need for scrollable_hk class
                this.removeClass(hotkeysElement, "scrollable_hk");
            }
        }
    };

    return AgentShortcutPopup;

});
